import React, {
  Component
} from 'react';

require('../styles/App.css');
require('../styles/About.css');

class About extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div className="about-container">
        <div className="about-text">
        {/* <p>www.other-people.network<br/>is a game of chance</p> */}
        <p>www.other-people.network</p>
        <p>Programming</p>
        <p>Cole Brown</p>
        <p>Artists (station posters)</p>
        <p>
          Jena Myung<br />
          Maziyar Pahlevan<br />
          Against All Logic<br />
        </p>

        <p>Design (site)</p>

        <p>
          Cole Brown<br />
          Against All Logic<br />
        </p>

        <p>Mixes</p>

        <p>
        Nicolas Jaar<br />
        Against All Logic<br />
        Ancient Astronaut<br />
        </p>

        <p>Actors</p>

        <p>
          Jonathan Gordon<br />
          Madeline Wise<br />
          Sean Patrick McGowan<br />
          Justin Kuritzkes<br />
          Celine Song<br />
          Gary Goldman<br />
        </p>

        <p>Special Thanks</p>

        <p>
          Africanus Okokon &lt;3 :) ;)<br />
          Ben Rafson &lt;3 &lt;3 &lt;3 !<br />
          Callie Barlow &lt;3 &lt;3 &lt;3 ! ! !<br />
          Celine Song + + +<br />
          Cole Brown &lt;3 &lt;3 &lt;3  : : : ) ) )<br />
          Jena Myung &lt;3 &lt;3 &lt;3<br />
          John Gordon !<br />
          Justin Kuritzkes + + +<br />
          Maddie Wise !<br />
          Mark Byrne &lt;3 &lt;3 &lt;3 !<br />
          Maziyar Pahlevan &lt;3 &lt;3 &lt;3<br />
          Milo Cordell &lt;3 &lt;3 &lt;3 !<br />
          Raf Rennie ...<br />
          Sean Patrick McGowan !<br />
        </p>

        <p>www.other-people.network</p>
        {/* <p>is a mix based on chance operations</p> */}
        </div>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/containers/About.js